import React from 'react';

const options = [
  { value: '1', text: '1 month' },
  { value: '2', text: '2 months' },
  { value: '3', text: '3 months' },
  { value: '4', text: '4 months' },
  { value: '5', text: '5 months' },
  { value: '6', text: '6 months' },
  { value: '7', text: '7 months' },
  { value: '8', text: '8 months' },
  { value: '9', text: '9 months' },
  { value: '10', text: '10 months' },
  { value: '11', text: '11 months' },
  { value: '12', text: '1 year' },
  { value: '15', text: '1 year 3 months' },
  { value: '18', text: '1 year 6 months' },
  { value: '21', text: '1 year 9 months' },
  { value: '24', text: '2 years' },
];

const LengthOfStay = ({ updateProfile, profileData }) => {
  const handleChange = (event) => {
    const { name, value } = event.target;
    updateProfile(name, parseInt(value, 10), 'term_preferences');
  };

  return (
    <fieldset className="form-group from-group--rental-period">
      <legend className="form-group__title">Minimum rental period</legend>
      <span className="form-group__select">
        <label className="sr-only" htmlFor="minTerm">
          Minimum period accommodation required for
        </label>
        <select
          name="min_term"
          id="minTerm"
          onChange={handleChange}
          value={profileData && profileData.min_term}
        >
          <option value="0">No minimum</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.text}
            </option>
          ))}
        </select>
        <div className="form-group__select-icon">
          <i className="far fa-chevron-down" aria-hidden="true"></i>
        </div>
      </span>
      <span className="form-group__linking-text">to</span>
      <span className="form-group__select">
        <label className="sr-only" htmlFor="maxTerm">
          Maximum period accommodation required for
        </label>
        <select
          name="max_term"
          id="maxTerm"
          onChange={handleChange}
          value={profileData && profileData.max_term}
        >
          <option value="0">No maximum</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.text}
            </option>
          ))}
          <option value="36">3 Years</option>
        </select>
        <div className="form-group__select-icon">
          <i className="far fa-chevron-down" aria-hidden="true"></i>
        </div>
      </span>
    </fieldset>
  );
};

export default LengthOfStay;
